module.exports = __webpack_public_path__ + "media/d24eee7ed26341afbc4915ccc49ff127.6fb86614.mp4";